(() => {
  const signup = document.querySelector('[data-lac-cart-email]');
  const config = document.querySelector('[data-lac-cart-labels]');
  let pending = false;
  let observedCart;
  let discountExpanded = false;
  let discountRefreshPending = false;
  let discountRefreshTimer;
  let lastCartSignature;
  const observer = new MutationObserver(schedule);
  const upgradePrices = new Map();

  function updateUpgradePrice(cartElement) {
    const offer = cartElement.querySelector('#rebuy-widget-209232');
    if (!offer) return;
    const widget = window.Rebuy?.widgets?.find(item => String(item.id) === '209232');
    const product = widget?.data?.products?.find(item => String(item.selected_variant?.id) === '41761664827488');
    const currency = window.Rebuy?.Cart?.cart?.currency;
    const rate = Number(window.Shopify?.currency?.rate);
    if (!product || !currency || !(rate > 0)) return;
    const discount = widget.hasProductDiscount(product) ? product.discount : widget.getWidgetDiscount(product);
    if (discount?.type !== 'fixed' || !(Number(discount.amount) >= 0)) return;
    const key = `${currency}:${rate}`;
    let record = upgradePrices.get(key);
    if (!record) {
      record = { pending: true };
      upgradePrices.set(key, record);
      const url = new URL(window.Shopify?.routes?.root || '/', location.origin);
      url.searchParams.set('section_id', 'lac-cart-upgrade-price');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error('Upgrade price unavailable');
          return response.text();
        })
        .then(html => {
          const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lac-upgrade-prices]');
          const result = JSON.parse(data?.textContent || 'null');
          if (result?.currency !== currency) throw new Error('Upgrade currency mismatch');
          record.data = result;
        })
        .catch(() => {})
        .finally(() => { record.pending = false; schedule(); });
    }
    const variant = record.data?.variants?.find(item => String(item.id) === String(product.selected_variant.id));
    if (!variant || !Number.isFinite(variant.price)) {
      if (offer.style.display !== 'none') offer.style.display = 'none';
      return;
    }
    if (offer.style.display === 'none') offer.style.removeProperty('display');
    const conversion = currency === record.data.shopCurrency ? 1 : rate;
    const digits = new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
    const scale = 10 ** digits;
    const convertedDiscount = Math.round(Number(discount.amount) * conversion * scale) / scale;
    const price = Math.max(0, Math.round(variant.price - convertedDiscount * 100));
    const formatted = money(price, currency);
    const sale = offer.querySelector('.rebuy-product-price .rebuy-money.sale > span:not(.sr-only)');
    const original = offer.querySelector('.rebuy-product-price .rebuy-money.compare-at > span:not(.sr-only)');
    if (sale && sale.textContent !== formatted) sale.textContent = formatted;
    const regular = money(variant.price, currency);
    if (original && original.textContent !== regular) original.textContent = regular;
    const title = offer.querySelector('.primary-title');
    if (title) {
      const prefix = title.dataset.lacUpgradePrefix || title.textContent.replace(/\s+(?:US|MX)?\$\s*[\d,.]+.*$/, '');
      title.dataset.lacUpgradePrefix = prefix;
      const text = `${prefix} ${formatted}`;
      if (title.textContent !== text) title.textContent = text;
      const region = offer.querySelector('[role="region"]');
      if (region?.getAttribute('aria-label') !== text) region?.setAttribute('aria-label', text);
    }
  }

  function refreshDiscountSummary() {
    if (!discountRefreshPending || typeof window.discountOnCartProApp?.updateWidgets !== 'function') return;
    const cart = window.Rebuy?.Cart?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    discountRefreshPending = false;
    window.discountOnCartProApp.updateWidgets();
  }

  function cartChanged() {
    const cart = window.Rebuy?.Cart?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    const signature = JSON.stringify([cart.currency, cart.total_price, cart.total_discount,
      cart.items.map(item => [item.key, item.quantity, item.final_line_price, item.line_price])]);
    if (signature === lastCartSignature) return;
    lastCartSignature = signature;
    discountRefreshPending = true;
    clearTimeout(discountRefreshTimer);
    discountRefreshTimer = setTimeout(refreshDiscountSummary, 150);
  }

  let rowGroups = new WeakMap();
  let groupBusy = false;
  let observedSubtotal;
  const subtotalObserver = new MutationObserver(schedule);

  function money(value, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency
    }).format(value / 100);
  }

  function groupKey(item) {
    if (!item.variant_id || item.selling_plan_allocation || Object.keys(item.properties || {}).length ||
        item.final_price !== item.original_price || item.final_price <= 0) return item.key;
    return JSON.stringify([item.variant_id, item.original_price, item.final_price]);
  }

  function updateRows(cartElement) {
    const cart = window.Rebuy?.Cart?.cart;
    const smartcart = window.Rebuy?.SmartCart;
    if (!cart?.currency || !Array.isArray(cart.items) || typeof smartcart?.items !== 'function') return;
    const items = smartcart.items().filter(item => !smartcart.isHiddenItem?.(item));
    const rows = Array.from(cartElement.querySelectorAll('[data-smartcart-items] > .rebuy-cart__flyout-item'));
    if (rows.length !== items.length || rows.some((row, index) => !row.classList.contains('product-' + items[index].handle))) return;
    const groups = new Map();
    rowGroups = new WeakMap();
    items.forEach((item, index) => {
      const key = groupKey(item);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push({ item, row: rows[index] });
    });
    groups.forEach(entries => {
      const promotionSplit = entries.length > 1 && entries.some(({ item }) =>
        (item.line_level_discount_allocations || []).some(discount =>
          discount.amount === 0 && /install.*kit/i.test(discount.discount_application?.title || '')));
      entries.forEach(({ item, row }, index) => {
        row.classList.toggle('lac-cart-split-hidden', promotionSplit && index > 0);
        row.classList.toggle('lac-cart-grouped', promotionSplit && index === 0);
        const group = promotionSplit ? entries.map(entry => entry.item) : [item];
        const quantity = group.reduce((sum, line) => sum + line.quantity, 0);
        const total = group.reduce((sum, line) => sum + line.final_line_price, 0);
        const label = row.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
        if (label) {
          if (promotionSplit && index === 0) {
            label.dataset.lacQuantity = String(quantity);
            label.setAttribute('role', 'img');
            label.setAttribute('aria-label', 'Quantity: ' + quantity);
            rowGroups.set(row, group);
          } else {
            delete label.dataset.lacQuantity;
            label.removeAttribute('role');
            label.removeAttribute('aria-label');
          }
        }
        const price = row.querySelector('.rebuy-cart__flyout-item-price');
        const title = row.querySelector('.rebuy-cart__flyout-item-product-title');
        const freeKit = /install(?:ation)?[ -]?kit/i.test(item.product_title || item.title || '') && total === 0;
        if (price && Number.isFinite(total)) {
          price.classList.add('lac-cart-price-enhanced');
          price.classList.toggle('lac-cart-free-price', freeKit);
          price.dataset.lacTotal = freeKit ? 'FREE' : money(total, cart.currency);
          price.dataset.lacEach = quantity > 1 && !freeKit ? money(item.final_price, cart.currency) + ' each' : '';
        }
        title?.classList.toggle('lac-cart-included-kit', freeKit);
      });
    });
    const subtotal = cartElement.querySelector('.rebuy-cart__flyout-subtotal');
    if (subtotal && observedSubtotal !== subtotal) {
      subtotalObserver.disconnect();
      subtotalObserver.observe(subtotal, { attributes: true, attributeFilter: ['style'] });
      observedSubtotal = subtotal;
    }
    const manualCodes = window.discountOnCartProApp?.codes || [];
    const authoritative = !manualCodes.length && Number.isFinite(cart.total_price);
    cartElement.classList.toggle('lac-cart-native-total', authoritative);
    if (subtotal && authoritative) {
      if (subtotal.style.display !== 'flex') subtotal.style.setProperty('display', 'flex', 'important');
      subtotal.dataset.lacSubtotal = money(cart.total_price, cart.currency);
      subtotal.setAttribute('aria-label', 'Subtotal: ' + money(cart.total_price, cart.currency));
    } else if (subtotal) {
      subtotal.removeAttribute('aria-label');
      if (subtotal.classList.contains('docapp-replaces') && subtotal.style.display !== 'none') subtotal.style.setProperty('display', 'none', 'important');
    }
  }

  function changeGroupedQuantity(event) {
    const button = event.target.closest?.('#rebuy-cart .rebuy-cart__flyout-item button');
    const row = button?.closest('.rebuy-cart__flyout-item');
    const group = row && rowGroups.get(row);
    if (!group || (!button.matches('.rebuy-cart__flyout-item-remove') &&
        !button.matches('.rebuy-cart__flyout-item-quantity-widget-button'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (groupBusy) return;
    const api = window.Rebuy?.Cart;
    if (!api?.changeItem || !api?.updateItem) return;
    const current = api.cart.items;
    if (!group.every(item => current.some(line => line.key === item.key && line.quantity === item.quantity))) { schedule(); return; }
    groupBusy = true;
    row.setAttribute('aria-busy', 'true');
    row.classList.add('lac-cart-group-busy');
    const done = () => {
      groupBusy = false;
      row.removeAttribute('aria-busy');
      row.classList.remove('lac-cart-group-busy');
      schedule();
    };
    const options = { success: done, error: done };
    if (button.matches('.rebuy-cart__flyout-item-remove')) {
      api.updateItem({ updates: Object.fromEntries(group.map(item => [item.key, 0])) }, options);
    } else {
      const buttons = Array.from(row.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button'));
      const increase = button === buttons[buttons.length - 1];
      const item = group.find(line => !(line.line_level_discount_allocations || []).length) || group[0];
      const increment = item.quantity_rule?.increment || 1;
      api.changeItem({ id: item.key, quantity: Math.max(0, item.quantity + (increase ? increment : -increment)) }, options);
    }
  }

  function updateViewport() {
    const cart = document.getElementById('rebuy-cart');
    if (!cart) return;
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    const top = viewport?.offsetTop || 0;
    cart.style.setProperty('--lac-cart-height', height + 'px');
    cart.style.setProperty('--lac-cart-top', top + 'px');
  }

  function collapseDiscount(container, field) {
    if (!field || container.querySelector('[data-lac-discount-toggle]')) return;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'lac-cart-discount-toggle';
    toggle.dataset.lacDiscountToggle = '';
    toggle.textContent = config?.dataset.discountLabel || 'Have a discount code?';
    toggle.setAttribute('aria-expanded', String(discountExpanded));
    field.classList.add('lac-cart-discount-fields');
    container.classList.toggle('lac-cart-discount-collapsed', !discountExpanded);
    container.prepend(toggle);
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      discountExpanded = expanded;
      toggle.setAttribute('aria-expanded', String(expanded));
      container.classList.toggle('lac-cart-discount-collapsed', !expanded);
      if (expanded) field.querySelector('input')?.focus();
    });
    field.querySelector('input')?.setAttribute('aria-label', 'Discount code');
    const apply = field.querySelector('.docapp-coupon-input--button');
    if (apply) {
      apply.setAttribute('role', 'button');
      apply.setAttribute('aria-label', 'Apply discount code');
      apply.addEventListener('keydown', event => {
        if (event.key === ' ') {
          event.preventDefault();
          apply.click();
        }
      });
    }
  }

  function compactSignup() {
    if (!signup) return;
    const email = signup.querySelector('input[type="email"]');
    const consent = signup.querySelector('input[name="gdpr"]');
    const submit = signup.querySelector('button[type="submit"]');
    const form = email?.closest('form');
    if (!form) return;
    email.closest('[class*="-field-container-wrapper-"]')?.classList.add('lac-cart-email-field');
    consent?.closest('[class*="-field-container-wrapper-"]')?.classList.add('lac-cart-email-consent');
    submit?.parentElement.classList.add('lac-cart-email-action');
    if (submit && submit.textContent.trim() === 'Sign Up & Save') {
      submit.textContent = config?.dataset.signupLabel || 'Get 10% off';
    }
    form.querySelectorAll('p').forEach(paragraph => {
      if (paragraph.textContent.trim() === 'Sign up for email and get 10% off your first order.') {
        paragraph.parentElement.classList.add('lac-cart-email-repeated-copy');
      }
    });
  }

  function mount() {
    pending = false;
    const cart = document.getElementById('rebuy-cart');
    if (!cart) return;
    if (observedCart !== cart) {
      observer.disconnect();
      observer.observe(cart, { childList: true, characterData: true, subtree: true });
      observedCart = cart;
    }
    const scrollArea = cart.querySelector('[data-rebuy-cart-scroll-area]');
    const footer = cart.querySelector('[data-rebuy-cart-anchor="footer"]');
    if (scrollArea && footer) {
      if (signup && signup.parentElement !== scrollArea) scrollArea.append(signup);
      footer.querySelectorAll(':scope > [data-rebuy-component="cross-sell-widget"], :scope > [data-rebuy-component="notes"]').forEach(component => {
        scrollArea.append(component);
      });
    }
    cart.querySelectorAll('.docapp-coupon-input').forEach(container => {
      collapseDiscount(container, container.querySelector('.docapp-coupon-input--input-container'));
    });
    cart.querySelectorAll('[data-rebuy-component="discount-input"]').forEach(container => {
      collapseDiscount(container, container.querySelector('form'));
    });
    updateRows(cart);
    updateUpgradePrice(cart);
    updateViewport();
    compactSignup();
    cartChanged();
    if (discountRefreshPending) {
      clearTimeout(discountRefreshTimer);
      discountRefreshTimer = setTimeout(refreshDiscountSummary, 150);
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(mount);
  }
  document.addEventListener('click', changeGroupedQuantity, true);
  document.addEventListener('rebuy:smartcart.ready', schedule);
  document.addEventListener('rebuy:smartcart.show', schedule);
  document.addEventListener('rebuy:cart.change', schedule);
  document.addEventListener('rebuy:cart.change', cartChanged);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', updateViewport, { passive: true });
  schedule();
})();
